import configureStore from './configureStore';

const store = configureStore({});

export default store;

export * from './reducers';



// WEBPACK FOOTER //
// ./src/store/index.ts